import React, { Suspense, lazy } from 'react'
import PropTypes from 'prop-types'
import { FroalaTextEditor, Loader } from 'components/UIElements'
import NewConsentQuestionView from './NewConsentQuestionView'

const ConsentSignatureView = lazy(() =>
  import(/* webpackChunkName: "dnd-kit-consent" */ './ConsentSignature/ConsentSignatureView'),
)

const ItemListView = props => {
  const { order } = props
  return (
    <div className='page-break'>
      {order.map(itemId => {
        const item = props.questions[itemId]
        return (
          <div className='survey-question avoid-break' key={itemId}>
            {item.attributes.questionNumber && item.type !== 'signature' && (
              <span>{`${item.attributes.questionNumber}.`}</span>
            )}
            <FroalaTextEditor value={item.label} readOnly={true} showToolbar={false} />
            <NewConsentQuestionView preview itemId={itemId} item={item} />
            {item.type === 'signature' && (
              <Suspense fallback={<div className='flexed center-justified' style={{ minHeight: 40 }}><Loader inContainer size={18} /></div>}>
                <ConsentSignatureView />
              </Suspense>
            )}
          </div>
        )
      })}
    </div>
  )
}

ItemListView.propTypes = {
  order: PropTypes.array,
  questions: PropTypes.object,
}

export default ItemListView
